<template>
  <div>
    <el-tabs v-model="activeName" >
      <el-tab-pane label="应付明细" name="one" style="">
        <tabYF v-if="activeName=='one'"></tabYF>
      </el-tab-pane>
      <el-tab-pane label="账单管理" name="two">
        <!-- <maintainUsers :basic-data="basicData"  v-if="activeName=='two'"></maintainUsers> -->
        <tabYFZDGL v-if="activeName=='two'"></tabYFZDGL>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import tabYF from '@/views/newTMS/transportation/caiWuManage/internal/YFcalculate/HSYF.vue'
import tabYFZDGL from '@/views/newTMS/transportation/caiWuManage/internal/YFcalculate/HSYFZD.vue'
export default {
  components: {
    tabYF,
    tabYFZDGL
  },
  data () {
    return {
      activeName: 'one'
    }
  }
}
</script>
<style scoped lang='less'>
/deep/.el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
    background-color: #0c46a2 !important;
    color: #fff;
}
/deep/.el-tabs__header{
  margin: 0;
}
</style>
